import React, { useContext } from 'react'
import { ButtonContainer, ButtonDiv, CloseDiv, Container, Header, InfosContainer, RowDatas } from './style'
import close from '../../../assets/close-icon.svg'
import pencil from '../../../assets/productions/pencil.svg'
import ModalContext from '../../../contexts/ModalContext'
import { fieldsAndValues } from '../CreateUserModal/utils'
import { ProductionUserContext } from '../../../contexts/ProductionUser'

const CheckUserModal:React.FC = () => {
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { productionUser } = useContext(ProductionUserContext)

  const handleEdit = () => {
    setModalActive(true)
    setModalSection('editUser')
  }
  
  return(
    <Container>
      <Header>
        <h2>Usuário: {productionUser.fullName}</h2>
        <CloseDiv onClick={() => (setModalActive(false))}>
          <img src={close} />
        </CloseDiv>
      </Header>
      <InfosContainer>
        {fieldsAndValues.map((item, index) => (
          <>
            {item.value !== 'fullName' ?
              <RowDatas key={index}>
                {item.label}
                <span>
                  {['costPerHour', 'costPerExtraHour'].includes(item.value) ?
                  <>
                    R$ {Number(productionUser[item.value as keyof typeof productionUser]).toFixed(2).replace('.',',')}
                  </>
                  : 
                  <>
                    {productionUser[item.value as keyof typeof productionUser]}
                  </>
                  }
                </span>
              </RowDatas>
            : null}
          </>
        ))}
      </InfosContainer>
      <ButtonContainer>
        <ButtonDiv onClick={() => handleEdit()}>
          <img src={pencil} />
          Editar usuário
        </ButtonDiv>
      </ButtonContainer>
    </Container>
  )
}

export default CheckUserModal